import { BookingsAvailableResponseType } from '../teeTimes/types';
import { GolfIdVerificationStatus, ProfileType } from './types';

const SWEDEN_COUNTRY_CODE = 'SE';
const SWEDEN_CURRENCY_CODE = 'SEK';

export const getGolfIdVerificationStatus = (
  profile?: ProfileType | null
): GolfIdVerificationStatus => {
  if (!profile) return GolfIdVerificationStatus.UNKNOWN;

  if (profile.countryCode !== SWEDEN_COUNTRY_CODE) return GolfIdVerificationStatus.NOT_AVAILABLE;

  return profile.gitPersonId
    ? GolfIdVerificationStatus.VERIFIED
    : GolfIdVerificationStatus.REQUIRED;
};

export const isGolfCourseRequireGolfIdVerification = (
  availability: BookingsAvailableResponseType
) => availability.currency.name === SWEDEN_CURRENCY_CODE;
